import { render, staticRenderFns } from "./Garantie.vue?vue&type=template&id=ba06e2b4&"
import script from "./Garantie.vue?vue&type=script&lang=js&"
export * from "./Garantie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports